import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const MainContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  gap: "20px",
});

export const SectionContainer = styled(Grid)(({ theme }) => ({
  flex: 1,
  height: "100%",
  overflow: "auto",
  background: theme.palette.background.paper,
}));

export const TypeStatusContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
}));

export const FlagIconStatusContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "flex-start",
  gap: "5px",
}));

export const AmountsBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
});

export const RowTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

export const AmountBlock = styled(Grid)({
  overflow: "hidden",
});

export const Amounts = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isAcceptedOrDifference",
})<{ isAcceptedOrDifference?: "accepted" | "difference" }>(
  ({ theme }) => ({
    textTransform: "uppercase",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "end",
    textWrap: "nowrap",
  }),
  ({ isAcceptedOrDifference, theme }) => ({
    ...(isAcceptedOrDifference === "accepted" && {
      color: theme.palette.success.main,
      fontWeight: "bold",
    }),
    ...(isAcceptedOrDifference === "difference" && {
      color: theme.palette.error.main,
      fontWeight: "bold",
    }),
  })
);

export const ClientGuestsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});

export const DetailsBlock = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  padding: "20px",
});

export const DifferenceAdditionalText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  lineHeight: "14px",
  marginTop: "4px",
}));
